import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-update-status',
    templateUrl: './update-status.component.html',
    styleUrls: ['./update-status.component.scss'],
    standalone: false
})
export class UpdateStatusComponent implements OnInit {
  @Input() title: string;
  @Input() information: string;
  @Input() info: string;
  @Input() positiveButton: string;
  @Input() negativeButton: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
